import React from 'react';
import { Box } from '@mui/material';
import { PatientComplementIcon } from '../PatientClassificationIcon';
import { LineThrough } from '../../../ui/LineThrough';
import { RedLabel } from '../../../messages/labels';

type PatientNameProps = {
    name: string;
    additionalInformation: Array<number> | undefined;
    onPaymentList?: boolean | undefined;
    canSeeFullContent: boolean | undefined;
    status?: string;
};

export const PatientName: React.FC<PatientNameProps> = ({
    name,
    additionalInformation,
    onPaymentList = true,
    canSeeFullContent = false,
    status,
}) => {
    const [information, setInformation] = React.useState<Array<number>>();
    const [fullContent, setFullContent] = React.useState<boolean>();
    const displayName = String(name ?? '').toUpperCase();

    React.useEffect(() => {
        setInformation(additionalInformation ? additionalInformation.sort() : undefined);
        setFullContent(canSeeFullContent ? canSeeFullContent : false);
    }, [additionalInformation, onPaymentList, canSeeFullContent]);

    const isInactive = status?.toLowerCase() === 'inativo';

    return (
        <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                {fullContent && !onPaymentList ? (
                    <span>
                        <LineThrough>{displayName}</LineThrough>
                    </span>
                ) : (
                    <span>{displayName}</span>
                )}
                {isInactive ? (
                    <RedLabel
                        style={{
                            width: '70px',
                            fontSize: '10px',
                            textTransform: 'uppercase',
                            lineHeight: '18px',
                        }}
                    >
                        Inativo
                    </RedLabel>
                ) : (
                    <></>
                )}
            </span>
            <span style={{ marginLeft: '5px', width: 'fit-content' }}>
                {fullContent &&
                    information?.map((i, idx) => (
                        <PatientComplementIcon
                            statusComplementId={i}
                            key={idx}
                            onPaymentList={onPaymentList}
                        ></PatientComplementIcon>
                    ))}
            </span>
        </Box>
    );
};
